var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpiredSoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 12C10.0899 12 13 9.31371 13 6C13 2.68629 10.0899 0 6.5 0C2.91015 0 0 2.68629 0 6C0 9.31371 2.91015 12 6.5 12Z",
    fill: "#F95151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17676 7.59912H5.8877L5.70508 2.17969H7.35938L7.17676 7.59912ZM6.53223 8.44775C6.79362 8.44775 7.00309 8.52474 7.16064 8.67871C7.32178 8.83268 7.40234 9.02962 7.40234 9.26953C7.40234 9.50586 7.32178 9.70101 7.16064 9.85498C7.00309 10.009 6.79362 10.0859 6.53223 10.0859C6.27441 10.0859 6.06494 10.009 5.90381 9.85498C5.74626 9.70101 5.66748 9.50586 5.66748 9.26953C5.66748 9.0332 5.74626 8.83805 5.90381 8.68408C6.06494 8.52653 6.27441 8.44775 6.53223 8.44775Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredSoon);
export default __webpack_public_path__ + "static/media/expired-soon.263a30d8.svg";
export { ForwardRef as ReactComponent };